import { default as domainAmbienceResource } from './resource/store'
import { default as domainAmbience } from './ambience/store'
import { default as domainAmbienceCategory } from './category/store'

export default {
    domainAmbienceResource,
    domainAmbience,
    domainAmbienceCategory
}